import React, { useCallback } from "react";

import { faTextSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Editor } from "slate";
import { useSlate } from "slate-react";

import { REMOVABLE_TEXT_TYPES } from "../../util/const";
import ToggleButton from "../ToggleButton";

import ActionTooltipWrapper from "./ActionTooltipWrapper";

const ClearStyles = () => {
  const editor = useSlate();

  const handleDropStyles = useCallback(() => {
    REMOVABLE_TEXT_TYPES.forEach((type) => {
      Editor.removeMark(editor, type);
    });
  }, [editor]);

  return (
    <ActionTooltipWrapper translationString={"ui.emailBody.toolbar.removeFormatting"}>
      <ToggleButton onClick={handleDropStyles}>
        <FontAwesomeIcon icon={faTextSlash} size="xs" />
      </ToggleButton>
    </ActionTooltipWrapper>
  );
};

export default ClearStyles;
